import { ref, onMounted, onUnmounted } from 'vue'
import { ElNotification } from 'element-plus'

const POLL_INTERVAL = 60 * 1000 // 60 秒检查一次

let currentVersion = ''
let timer: ReturnType<typeof setInterval> | null = null
let notified = false

async function fetchVersion(): Promise<string> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`)
    if (res.ok) {
      const data = await res.json()
      return data.version || ''
    }
  } catch { /* ignore */ }
  return ''
}

export function useVersionCheck() {
  const hasUpdate = ref(false)

  async function check() {
    const remote = await fetchVersion()
    if (!currentVersion) {
      currentVersion = remote
      return
    }
    if (remote && remote !== currentVersion && !notified) {
      hasUpdate.value = true
      notified = true
      ElNotification({
        title: '发现新版本',
        message: '检测到网站已更新，建议刷新页面以获取最新功能和修复。',
        type: 'warning',
        duration: 0,
        position: 'top-right',
        showClose: true,
        onClick: () => {
          window.location.reload()
        },
      })
    }
  }

  onMounted(() => {
    check()
    timer = setInterval(check, POLL_INTERVAL)
  })

  onUnmounted(() => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  })

  return { hasUpdate }
}
